import { useEffect, useState } from "react";
import * as styles from "./styles.module.css";
import useGeoLocation from "../../hooks/useGeoLocation";
import { gdprCountries } from "../../../static/constants";

function CookieConsent() {
    const [currentCountry] = useGeoLocation();
    const [showConsent, setShowConsent] = useState(false);

    const restrictedURLs = [];

    const initialConsentState = () => {
        if (
            typeof window !== "undefined" &&
            !restrictedURLs.includes(window.location.pathname)
        ) {
            const localStorageConsent = localStorage.getItem(
                "cookieConsentConfig"
            );

            if (!gdprCountries.includes(currentCountry.country)) {
                if (localStorageConsent === null) {
                    const initialObj = JSON.stringify({
                        showConsentBar: true,
                        allowCookie: true,
                        country: currentCountry.country,
                    });
                    localStorage.setItem("cookieConsentConfig", initialObj);
                    sessionStorage.setItem("allowGtm", "true");
                    setShowConsent(true);
                } else {
                    const storedState = JSON.parse(localStorageConsent);

                    if (storedState.showConsentBar === true) {
                        const initialObj = JSON.stringify({
                            showConsentBar: true,
                            allowCookie: true,
                            country: currentCountry.country,
                        });
                        localStorage.setItem("cookieConsentConfig", initialObj);
                        sessionStorage.setItem("allowGtm", "true");
                        setShowConsent(true);
                    } else {
                        setShowConsent(false);
                    }
                }
            }
        }
    };

    useEffect(() => {
        initialConsentState();
    }, [currentCountry.country]);

    const handleEnableCookie = () => {
        let storedState = JSON.parse(
            localStorage.getItem("cookieConsentConfig")
        );
        storedState.showConsentBar = false;
        storedState.allowCookie = true;
        storedState.country = currentCountry.country;
        localStorage.setItem(
            "cookieConsentConfig",
            JSON.stringify(storedState)
        );
        sessionStorage.setItem("allowGtm", "true");

        var evt = document.createEvent("StorageEvent");
        evt.initStorageEvent(
            "storage",
            false,
            false,
            "allowGtm",
            "oldValue",
            "newValue",
            null,
            window.localStorage
        );
        window.dispatchEvent(evt);
        window.location.reload();
        setShowConsent(false);
        console.log("enabled");
    };

    const handleDisableCookie = () => {
        let storedState = JSON.parse(
            localStorage.getItem("cookieConsentConfig")
        );
        console.log(storedState, "Decline  click");

        storedState.showConsentBar = false;
        storedState.allowCookie = false;
        storedState.country = currentCountry.country;
        localStorage.setItem(
            "cookieConsentConfig",
            JSON.stringify(storedState)
        );
        sessionStorage.setItem("allowGtm", "false");

        var evt = document.createEvent("StorageEvent");
        evt.initStorageEvent(
            "storage",
            false,
            false,
            "allowGtm",
            "oldValue",
            "newValue",
            null,
            window.localStorage
        );
        window.dispatchEvent(evt);
        setShowConsent(false);
        console.log("disabled");
    };

    return (
        <>
            {showConsent ? (
                <>
                    <div className={`${styles.consentWrapper}`}>
                        <div
                            className={`${styles.exitBtn}`}
                            onClick={handleEnableCookie}
                        >
                            <p>X</p>
                        </div>
                        <div className="container">
                            <div className={`${styles.consentContent}`}>
                                <div className={`${styles.concentText}`}>
                                    <span className={`${styles.toptext}`}>
                                        We Value Your Privacy.
                                    </span>
                                    <br />
                                    <span className={`${styles.bottomtext}`}>
                                        This website utilizes cookies to
                                        optimize your browsing experience and
                                        collect analytics concerning our
                                        visitors by default. If you decline,
                                        your information will not be tracked.
                                        For additional information, kindly refer
                                        to our{" "}
                                        <a
                                            href="https://www.vantagecircle.com/privacy-policy/"
                                            className={`${styles.pp}`}
                                        >
                                            &nbsp;Privacy Policy
                                        </a>
                                    </span>
                                </div>
                                <div>
                                    <button
                                        onClick={handleEnableCookie}
                                        className={`${styles.allowBtn}`}
                                    >
                                        Allow Cookies
                                    </button>
                                    <button
                                        onClick={handleDisableCookie}
                                        className={`${styles.declineBtn}`}
                                    >
                                        Decline Cookies
                                    </button>
                                </div>
                            </div>
                        </div>
                        <br />
                        <br />
                    </div>
                </>
            ) : null}
        </>
    );
}

export default CookieConsent;
